/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'connection-delete': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M34 32.2l2.1 2.1-1.8 1.8-2.1-2.1-2.1 2.1-1.8-1.8 2.1-2.1-2.1-2.1 1.8-1.8 2.1 2.1 2.1-2.1 1.8 1.8-2.1 2.1zm-6.3-15.1v2.5c0 1.2-.9 2.1-2 2.2v5.4c0 .4-.1.8-.4 1l-2.5 2.6H26v3h-8.3c-.1 1.1-1.1 2-2.2 2H13c-1.2 0-2.2-1-2.2-2.2v-2.5c0-1.2 1-2.2 2.2-2.2h2.5c1.2 0 2.1.9 2.2 2h1l4.1-4.3v-4.8c-1.1-.1-2-1.1-2-2.2v-2.5c0-1.2 1-2.2 2.2-2.2h2.5c1.2-.1 2.2.9 2.2 2.2zm-12 14c0-.1-.1-.2-.2-.2H13c-.1 0-.2.1-.2.2v2.5c0 .1.1.2.2.2h2.5c.1 0 .2-.1.2-.2v-2.5zm10-14c0-.1-.1-.2-.2-.2H23c-.1 0-.2.1-.2.2v2.5c0 .1.1.2.2.2h2.5c.1 0 .2-.1.2-.2v-2.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/connection-delete.js